import { useEffect, useState } from "react";
import axios from "axios";
import Layout from "../components/Layout";

const Parties = () => {
  const [partyList, setPartyList] = useState([]);

  useEffect(() => {
    getParties();
  }, []);

  const getParties = () => {
    axios
      .get(
        "https://creatureparty.net/dashboard/wp-json/creatureparty/v1/parties"
      )
      .then((res) => {
        console.log(res.data);
        setPartyList(res.data);
      })
      .catch((err) => console.log(err));
  };

  return (
    <Layout>

    <section className="Parties">
      <ul className="Parties__List">
        {partyList.length > 0
          ? partyList.map((party, i) => {
              if (!party.info.banner?.large) return null;
              return (
                <li key={`party${i}`} className="Parties__Invitation">
                  {party.info.doors_open ? (
                    <a href={`/parties/${party.info.id}`}>
                      <img
                        src={party.info.banner.large}
                        title="Come on in!"
                      />
                    </a>
                  ) : (
                    <img
                      src={party.info.banner.large}
                      title="Coming soon ..."
                    />
                  )}
                </li>
              );
            })
          : null}
      </ul>
    </section>
    </Layout>
  );
};

export default Parties;
